import css from "./Hamburger.module.css";

function Hamburger(props) {
  return (
    <div
      className={css.hamburger}
      onMouseDown={() => {
        props.setEnableDrag(true);
      }}
      onMouseLeave={() => {
        props.setEnableDrag(false);
      }}
    >
      <div className={css.burger}></div>
      <div className={css.burger}></div>
      <div className={css.burger}></div>
    </div>
  );
}

export default Hamburger;
